export default {
  meta: {
    title: '店铺数据管理',
  },
};
